/** Copy for homepage — merged into `translations` as `homeRedesign`. */

export const homeRedesignEn = {
  seo: {
    title: 'Chisme - Make plans and meet women like you',
    description:
      'Chisme is the friendship app for women who are done waiting for plans to fall into their lap.',
  },
  nav: {
    logoAria: 'Chisme home',
    explorePlans: 'Explore the plans',
    openApp: 'Download',
    usersShort: '100k + users',
    usersLong: '100,000+ users',
  },
  hero: {
    headlineYou: 'Your ',
    headlinePeople: 'people',
    headlineL2: 'are already',
    headlineL3: 'nearby.',
    subBefore: 'Chisme is the friendship app for women who are ',
    subHighlight: 'done waiting',
    subAfter: ' for plans to fall into their lap.',
    ctaPrimary: 'Download Chisme ',
    ctaSecondary: 'Explore the plans',
    badgeBrunch: 'brunch · 4 friends',
    badgeRunClub: 'run club · sunday',
    badgePottery: 'pottery night · WBurg',
    socialLine1: '+ 100,000 women',
    socialLine2: 'looking for plans',
    finally: '“finally” ✿',
    floatingBarTitle: 'Find plans right now',
  },
  marquee: {
    items: [
      { label: 'barre class & coffee', variant: 'pink' as const },
      { label: 'bike loops in the park', variant: 'dark' as const },
      { label: 'sunset hikes & viewpoints', variant: 'pink' as const },
      { label: 'concert floor squads', variant: 'dark' as const },
      { label: 'tardeo & terrace drinks', variant: 'pink' as const },
      { label: 'korean dinner crews', variant: 'dark' as const },
      { label: 'new friends in your barrio', variant: 'pink' as const },
      { label: 'thrift runs & cafecito', variant: 'dark' as const },
    ],
  },
  lessAlone: {
    h2a: 'Less alone.',
    h2b: 'More invited.',
    bodyBefore: "We didn’t build another feed. We built the small, brave thing in the middle — the part where you ",
    bodyShowUp: 'show up',
    bodyAfter: ', actually.',
    rows: [
      { left: 'Texted three girls back.', right: 'They’re in.' },
      { left: 'Walked into pottery night.', right: 'Knew two faces.' },
      { left: 'Skipped doom-scrolling.', right: 'Made plans instead.' },
      { left: 'Moved to a new city.', right: 'Made it feel like home.' },
      { left: 'Posted “anyone want coffee?”', right: 'Got six replies.' },
    ],
  },
  testimonials: {
    h2a: 'Real friendships,',
    h2b: 'not screenshots of them.',
    carouselAria: 'Community reviews',
    cards: [
      {
        body: 'It deserves more recognition 😭😭❣️',
        name: 'Scarlett',
        place: 'Spain',
      },
      {
        body:
          'The photo at the start makes it trustworthy. I met up with the girls yesterday and it was great ☺️ Exactly what I was looking for.',
        name: 'A Chisme user',
        place: 'Spain',
      },
      {
        body:
          'Without paying anything I found real friends and a new social life. Out of hundreds of apps, it’s the only one that actually delivers. Thank you!',
        name: 'Jennifer',
        place: 'Spain',
      },
      {
        body: 'I love meeting people and making plans. This app makes it effortless. ❤️',
        name: 'Leti',
        place: 'Spain',
      },
      {
        body: 'They added Menorca when I asked. A thousand thanks! 🫂',
        name: 'Tonia',
        place: 'Menorca',
      },
    ],
  },
  chat: {
    h2a: 'Conversations',
    h2b: 'that turn into plans.',
    intro:
      'Every plan gets its own group chat. Sort out the time, drop the pin, bring a friend. Better than DMs that fizzle out.',
    stackRegionAria: 'Sample group chats for different plans',
    threads: [
      {
        threadTitle: 'terrace drinks · sat 6:30pm',
        threadSub: '12 going · Retiro',
        msg1: 'yess im in!! same spot as last time??',
        msg2: 'just dropped the pin',
        msg3: 'can i bring 2 girls from work or is that too much lol',
        msg4: 'bring them!! see u sat ✨',
      },
      {
        threadTitle: 'bike loop · sun 9am',
        threadSub: '5 going · Casa de Campo',
        msg1: 'south gate at 9?',
        msg2: 'yess. got an extra tube if anyone needs',
        msg3: 'coffee after??',
        msg4: 'done. sunday 🚴',
      },
      {
        threadTitle: 'barre + coffee · thu 7pm',
        threadSub: '8 going · Salamanca',
        msg1: 'they said 7:15 works',
        msg2: 'theres a cute cafe next door for after',
        msg3: 'want me to grab a table? were like 6',
        msg4: 'yes pls i need coffee after that class 😮‍💨',
      },
      {
        threadTitle: 'korean dinner · fri 8:30pm',
        threadSub: '4 going · Eixample',
        msg1: 'i think we should still book tbh',
        msg2: 'lots of veggie stuff on the menu',
        msg3: 'gonna be like 10 min late sorryyy',
        msg4: 'all good we wont order till ur here',
      },
      {
        threadTitle: 'sunset viewpoint · sat 7pm',
        threadSub: '6 going · Montjuïc',
        msg1: 'sunset is around 7:40 btw',
        msg2: 'bringing a jacket just in case',
        msg3: 'i have a blanket if we wanna sit 🧺',
        msg4: 'perfect see u there 📸',
      },
    ],
  },
  promise: {
    kicker: 'the chisme promise',
    h2a: 'Built for women,',
    h2b: 'kept that way.',
    trustPill: 'Verified · Moderated · Secure',
    pillars: [
      {
        title: 'Women centered.',
        body: 'Verified, every account. No exceptions.',
      },
      {
        title: 'Plans, not profiles.',
        body: 'Show up, not slide-in. Built for groups.',
      },
      {
        title: 'No swiping.',
        body: 'No matching, no games. Just plans.',
      },
      {
        title: 'Reportable, fast.',
        body: 'Real humans on call, not a queue.',
      },
    ],
  },
  ciudadesPage: {
    seoTitle: 'Cities - Plans and events for women | Chisme',
    seoDescription:
      'Discover plans and events in your city. Connect with women like you in Madrid, Barcelona, Miami, Orlando, Tampa, and more.',
  },
  cities: {
    h2a: 'Wherever',
    h2b: 'you land.',
    andManyMore: 'and many more',
  },
  finalCta: {
    h2a: 'Weekend is ',
    h2b: 'around the',
    h2c: 'corner.',
    body:
      'Free. Free of dudes. Free of weirdness. Two minutes to set up — the rest is up to you.',
    downloadOn: 'Download on',
    appStore: 'App Store',
    getItOn: 'GET IT ON',
    googlePlay: 'Google Play',
    photoBadge: 'downtown · friday',
  },
  storePicker: {
    title: 'Get Chisme',
    subtitle: 'Pick your app store to download.',
    closeAria: 'Close',
    appleLabel: 'App Store',
    googleLabel: 'Google Play',
  },
  appLinks: {
    seoTitle: 'Chisme — Download the app',
    seoDescription: 'Download Chisme, explore plans, and follow us on social.',
    headline: 'Your people are already nearby.',
    socialLine1: '+ 100,000 women',
    socialLine2: 'looking for plans',
    downloadSection: 'Download the app',
    ugcSection: 'Collaborate with Chisme',
    moreSection: 'More information',
    visitHomepage: 'About Chisme',
    ugcCreator: 'Collaborate as a UGC creator',
    explorePlans: 'Explore plans',
    explorePlansHint: 'See real plans in your city',
    followUs: 'Follow us',
    instagram: 'Instagram',
    tiktok: 'TikTok',
    madeWith: 'Made with 💜 for women everywhere',
    redirecting: 'Opening the app store…',
    openInStore: 'Download Chisme',
    openInBrowserHint: 'Tap to open the App Store',
    openInSafariTitle: "Doesn't open?",
    openInSafariStep1: 'Tap ⋯ at the top right',
    openInSafariStep2: 'Choose “Open in Safari”',
    openInSafariStep3: 'Tap Download again',
  },
  footer: {
    tagline: 'A friendship app for women, made with care',
    language: 'Language',
    product: 'product',
    legal: 'legal',
    howItWorks: 'How it works',
    cities: 'Cities',
    safety: 'Safety',
    forHosts: 'For hosts',
    partners: 'Partners',
    partnersNew: 'New',
    privacy: 'Privacy',
    terms: 'Terms',
    communityGuidelines: 'Community guidelines',
    copyright: '© 2026 chisme social',
    madeWith: 'made with care',
  },
};

export const homeRedesignEs = {
  seo: {
    title: 'Chisme - Haz planes y conoce mujeres como tú',
    description:
      'Chisme es la app de amistad para mujeres cansadas de esperar a que los planes caigan del cielo.',
  },
  nav: {
    logoAria: 'Inicio de Chisme',
    explorePlans: 'Ver planes',
    openApp: 'Descargar',
    usersShort: '100k + usuarias',
    usersLong: 'más de 100 000 usuarias',
  },
  hero: {
    headlineYou: 'Tu ',
    headlinePeople: 'gente',
    headlineL2: 'ya está',
    headlineL3: 'cerca.',
    subBefore: 'Chisme es la app de amistad para mujeres ',
    subHighlight: 'cansadas de esperar',
    subAfter: ' a que los planes caigan del cielo.',
    ctaPrimary: 'Descargar Chisme ',
    ctaSecondary: 'Explorar planes',
    badgeBrunch: 'brunch · 4 amigas',
    badgeRunClub: 'running · domingo',
    badgePottery: 'cerámica · WBurg',
    socialLine1: '+ 100.000 chicas',
    socialLine2: 'buscando planes',
    finally: '«por fin» ✿',
    floatingBarTitle: 'Encuentra planes ya',
  },
  marquee: {
    items: [
      { label: 'barre y café después', variant: 'pink' as const },
      { label: 'ruta en bici por el parque', variant: 'dark' as const },
      { label: 'atardeceres y miradores', variant: 'pink' as const },
      { label: 'conciertos y pista', variant: 'dark' as const },
      { label: 'tardeo y cervecitas', variant: 'pink' as const },
      { label: 'cenas coreanas y sushi', variant: 'dark' as const },
      { label: 'hacer amigas en el barrio', variant: 'pink' as const },
      { label: 'vintage y cafecito', variant: 'dark' as const },
    ],
  },
  lessAlone: {
    h2a: 'Menos sola.',
    h2b: 'Más invitada.',
    bodyBefore:
      'No construimos otro feed. Construimos lo pequeño y valiente del medio — la parte en la que tú ',
    bodyShowUp: 'apareces',
    bodyAfter: ', de verdad.',
    rows: [
      { left: 'Le escribí a tres chicas.', right: 'Dijeron que sí.' },
      { left: 'Entré a una noche de cerámica.', right: 'Conocía dos caras.' },
      { left: 'Dejé el doomscroll.', right: 'Hice planes.' },
      { left: 'Me mudé a otra ciudad.', right: 'Pareció un hogar.' },
      { left: 'Publiqué «¿alguien para un café?»', right: 'Seis respuestas.' },
    ],
  },
  testimonials: {
    h2a: 'Amistades de verdad,',
    h2b: 'no capturas de pantalla.',
    carouselAria: 'Opiniones de la comunidad',
    cards: [
      {
        body: 'Le falta más reconocimiento 😭😭❣️',
        name: 'Scarlett',
        place: 'España',
      },
      {
        body:
          'La foto al inicio la hace fiable. Ayer quedé con las chicas y salió genial ☺️ Era justo lo que buscaba.',
        name: 'Usuaria',
        place: 'España',
      },
      {
        body:
          'Sin tener que pagar nada encontré amigas de verdad y una vida social nueva. De cientos de apps, es la única que cumple lo que promete. ¡Mil gracias!',
        name: 'Jennifer',
        place: 'España',
      },
      {
        body: 'Me encanta conocer gente y hacer planes. Con esta app es facilísimo. ❤️',
        name: 'Leti',
        place: 'España',
      },
      {
        body: 'Añadieron Menorca cuando lo pedí. ¡Mil gracias! 🫂',
        name: 'Tonia',
        place: 'Menorca',
      },
    ],
  },
  chat: {
    h2a: 'Conversaciones',
    h2b: 'que se convierten en planes.',
    intro:
      'Cada plan tiene su chat. Ajustáis la hora, pasáis la ubicación y listo. Mucho mejor que escribir por MD y que no pase nada.',
    stackRegionAria: 'Ejemplos de chats para distintos planes',
    threads: [
      {
        threadTitle: 'cervecitas en la terraza · sáb 18:30',
        threadSub: '12 apuntadas · Retiro',
        msg1: 'apuntada!! mismo sitio del otro día no?',
        msg2: 'paso la ubicación ahora',
        msg3: 'llevo a 2 del curro, va bien? jajaja',
        msg4: 'venga trae, nos vemos el sábado ✨',
      },
      {
        threadTitle: 'ruta en bici · dom 9:00',
        threadSub: '5 apuntadas · Casa de Campo',
        msg1: 'puerta sur a las 9?',
        msg2: 'venga, llevo cámara de repuesto por si acaso',
        msg3: 'café después??',
        msg4: 'hecho, el domingo 🚴',
      },
      {
        threadTitle: 'barre + café · jue 19:00',
        threadSub: '8 apuntadas · Salamanca',
        msg1: 'me confirman las 19:15',
        msg2: 'hay un café buenísimo al lado para después',
        msg3: 'reservo mesa? somos unas 6',
        msg4: 'siii hace falta café después de esa clase 😮‍💨',
      },
      {
        threadTitle: 'cena coreana · vie 20:30',
        threadSub: '4 apuntadas · Eixample',
        msg1: 'yo reservaría igual',
        msg2: 'tienen cosas veggie la mar de bien',
        msg3: 'llego 10 min tarde perdon 😅',
        msg4: 'tranquila, no pedimos hasta que llegues',
      },
      {
        threadTitle: 'atardecer en el mirador · sáb 19:00',
        threadSub: '6 apuntadas · Montjuïc',
        msg1: 'ojo que el atardecer es sobre las 19:40',
        msg2: 'llevo chaqueta por si acaso',
        msg3: 'tengo manta por si nos sentamos 🧺',
        msg4: 'genial nos vemos allí 📸',
      },
    ],
  },
  promise: {
    kicker: 'la promesa chisme',
    h2a: 'Hecha para mujeres,',
    h2b: 'así se queda.',
    trustPill: 'Verificada · Moderada · Segura',
    pillars: [
      {
        title: 'Centrada en mujeres.',
        body: 'Cuenta verificada, todas. Sin excepciones.',
      },
      {
        title: 'Planes, no perfiles.',
        body: 'Aparece, no deslizar. Pensada para grupos.',
      },
      {
        title: 'Sin swipes.',
        body: 'Sin matches, sin juegos. Solo planes.',
      },
      {
        title: 'Reportes, rápido.',
        body: 'Humanas reales al otro lado, no una cola infinita.',
      },
    ],
  },
  ciudadesPage: {
    seoTitle: 'Ciudades - Planes y eventos para mujeres | Chisme',
    seoDescription:
      'Descubre planes y eventos en tu ciudad. Conecta con mujeres como tú en Madrid, Barcelona, Miami, Orlando, Tampa y más.',
  },
  cities: {
    h2a: 'Donde sea',
    h2b: 'que aterrices.',
    andManyMore: 'y muchas más',
  },
  finalCta: {
    h2a: 'El finde está ',
    h2b: 'a la vuelta',
    h2c: 'de la esquina.',
    body:
      'Gratis. Sin tíos. Sin rarezas. Dos minutos para empezar — el resto depende de ti.',
    downloadOn: 'Descargar en',
    appStore: 'App Store',
    getItOn: 'DISPONIBLE EN',
    googlePlay: 'Google Play',
    photoBadge: 'centro · viernes',
  },
  storePicker: {
    title: 'Chisme',
    subtitle: 'Elige tu tienda para descargar.',
    closeAria: 'Cerrar',
    appleLabel: 'App Store',
    googleLabel: 'Google Play',
  },
  appLinks: {
    seoTitle: 'Chisme — Descarga la app',
    seoDescription: 'Descarga Chisme, explora planes y síguenos en redes.',
    headline: 'Tu gente ya está cerca.',
    socialLine1: '+ 100.000 chicas',
    socialLine2: 'buscando planes',
    downloadSection: 'Descargar la app',
    ugcSection: 'Colabora con Chisme',
    moreSection: 'Más información',
    visitHomepage: 'Conoce Chisme',
    ugcCreator: 'Colabora como creadora UGC',
    explorePlans: 'Explorar planes',
    explorePlansHint: 'Ver planes reales en tu ciudad',
    followUs: 'Síguenos',
    instagram: 'Instagram',
    tiktok: 'TikTok',
    madeWith: 'Hecho con 💜 para mujeres en todas partes',
    redirecting: 'Abriendo la tienda de apps…',
    openInStore: 'Descargar Chisme',
    openInBrowserHint: 'Toca para abrir la App Store',
    openInSafariTitle: '¿No se abre?',
    openInSafariStep1: 'Toca ⋯ arriba a la derecha',
    openInSafariStep2: 'Elige “Abrir en Safari”',
    openInSafariStep3: 'Toca Descargar otra vez',
  },
  footer: {
    tagline: 'Una app de amistad para mujeres, hecha con mimo',
    language: 'Idioma',
    product: 'producto',
    legal: 'legal',
    howItWorks: 'Cómo funciona',
    cities: 'Ciudades',
    safety: 'Seguridad',
    forHosts: 'Para anfitrionas',
    partners: 'Para negocios',
    partnersNew: 'Novedad',
    privacy: 'Privacidad',
    terms: 'Términos',
    communityGuidelines: 'Normas de la comunidad',
    copyright: '© 2026 chisme social',
    madeWith: 'hecho con mimo',
  },
};

export type HomeRedesignStrings = typeof homeRedesignEn;
